<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19RYFWv/tc-custom/9781780106403.jpg?1726483288007" alt="This image is the cover for the book Dead Certainty, The Harry Radcliffe Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Certainty, The Harry Radcliffe Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b><i>A fast-paced mystery set in the cut-throat world of horse-racing: the first in the brand-new Harry Radcliffe series.</i></b><br/><br/>Recuperating after a serious accident, not knowing if he’ll ever ride again, champion jump jockey and racing columnist Harry Radcliffe accepts a commission to ghost-write the autobiography of retiring racehorse trainer Elspeth Maudsley. But as he begins to research her family history, it becomes increasingly clear to Harry that there are things Elspeth isn’t telling him about her past. What’s more, a series of threatening incidents, escalating in menace and intensity, begins to convince Harry that someone is determined to stop him writing this book – whatever it takes.<br/><br/>And Harry is about to uncover secrets in his own family’s past too. Secrets that will shake him to his core and ensure that he can never feel certain about anything again.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Glenis Wilson
      </h2>
      
      <p class="authorDescription body article">Glenis Wilson was born in Radcliffe-on-Trent, Nottinghamshire, where she lives to this day. She has been a member of the Nottingham Writers’ Club for thirty-five years, and is the author of seven previous novels, published in large print, and three previous Harry Radcliffe mysteries.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2120f09c